const SECTION_TYPES = ['description'];

export default SECTION_TYPES;
